import { Outlet, createFileRoute } from '@tanstack/react-router'

import { forbiddenErrorComponent, requirePermission } from '@/lib/routeGuards'

export const Route = createFileRoute('/_app/library')({
  component: Outlet,
  beforeLoad: ({ context }) => {
    requirePermission(context.permissions, 'read:definition')
  },
  errorComponent: forbiddenErrorComponent,
})
